module.exports = __webpack_public_path__ + "img/Ill_badge_input_manifest_gagal.de8f5b32.svg";